module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.2557cce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Light.svg
// module id = 327
// module chunks = 3